export const AppConfig = {
  passStatus: {
    pending: 0,
    registered: 1,
    declined: 2,
    canceled: 3,
    used: 4,
    expired: 5,
    denied: 6,
    inactive: 7,
    checkedIn: 8,
    suspended: 9,
  },
  passType: {
    undefined: 0,
    employee: 1,
    family: 5,
    vip: 6,
    goldCard: 7,
    guest: 10,
    vendor: 20,
    comp: 30,
    elite: 40,
    affiliate: 50,
    staff_dress: 60,
    converse: 201,
    swoosh: 101,
    converse_family: 205,
    swoosh_family: 105,
  },
  policyLocationIds: {
    unknown: 0,
    argentina: 32,
    austria: 40,
    belgium: 56,
    canada: 124,
    chile: 152,
    china: 156,
    croatia: 191,
    czech: 203,
    denmark: 208,
    france: 250,
    germany: 276,
    hongKong: 344,
    hungary: 348,
    india: 356,
    indonesia: 360,
    ireland: 372,
    italy: 380,
    japan: 392,
    korea: 410,
    malaysia: 458,
    mexico: 484,
    netherlands: 528,
    norway: 578,
    philippines: 608,
    poland: 616,
    portugal: 620,
    russia: 643,
    singapore: 702,
    vietnam: 704,
    spain: 724,
    sweden: 752,
    switzerland: 756,
    taiwan: 158,
    thailand: 764,
    unitedkingdom: 826,
    unitedStates: 840,
  },
  privacyPolicyLinks: [
    {
      countryCode: 32,
      link: 'http://agreementservice.svs.nike.com/ar/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=ar&language=es&requestType=redirect',
    },
    {
      countryCode: 124,
      link: 'http://agreementservice.svs.nike.com/ca/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=ca&language=en&requestType=redirect',
    },
    {
      countryCode: 152,
      link: 'http://agreementservice.svs.nike.com/cl/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=cl&language=es&requestType=redirect',
    },
    {
      countryCode: 156,
      link: 'https://agreementservice.svs.nike.com/cn/zh_cn/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.unite&country=CN&language=zh&requestType=redirect',
    }, // GC
    {
      countryCode: 158,
      link: 'https://agreementservice.svs.nike.com/tw/zh_tw/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=TW&language=zh&requestType=redirect',
    }, // TW
    { countryCode: 344, link: 'https://www.nike.com.hk/helpcenter/privacy_statement.htm' }, // HK
    {
      countryCode: 392,
      link: 'http://agreementservice.svs.nike.com/jp/ja_jp/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=jp&language=ja&requestType=redirect',
    },
    {
      countryCode: 394,
      link: 'http://agreementservice.svs.nike.com/kr/ko_kr/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=kr&language=ko&requestType=redirect',
    },
    {
      countryCode: 410,
      link: 'http://agreementservice.svs.nike.com/kr/ko_kr/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=kr&language=ko&requestType=redirect',
    }, // Korea
    {
      countryCode: 446,
      link: 'https://agreementservice.svs.nike.com/tw/zh_tw/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=TW&language=zh&requestType=redirect',
    }, // Macau
    {
      countryCode: 484,
      link: 'http://agreementservice.svs.nike.com/mx/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=mx&language=la&requestType=redirect',
    },
    {
      countryCode: 840,
      link: 'http://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=us&language=en&requestType=redirect',
    },
    {
      countryCode: 360,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
    {
      countryCode: 458,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
    {
      countryCode: 608,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
    {
      countryCode: 702,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
    {
      countryCode: 704,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
    {
      countryCode: 764,
      link: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    },
  ],
  regexPatterns: {
    regexEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    regexPersonNames: '^[^\\[\\]/#@=^,+()$~%:*`_?;|<>{}!\\\\]+$',
    regexOrgNames: '[^[]#=^,+()$~%:*`?;|<>{}\\\\]+',
    regexNumbers: '[0-9]+',
    regexMobile: /^\+(86)\d{11}$/,
  },
  validationMessages: {
    namesErrorMessage: "Sorry that character can't be used here",
    validEmailMessage: 'Please enter a valid email',
  },
  visitTypes: {
    undefined: 0,
    employee: 1,
    family: 5,
    vip: 6,
    goldCard: 7,
    guest: 10,
    vendor: 20,
    comp: 30,
    elite: 40,
    affiliate: 50,
    staff_dress: 60,
    converse: 201,
    swoosh: 101,
    converse_family: 205,
    swoosh_family: 105,
  },
  locales: {
    us: 'en-US',
    mexico: 'es-MX',
    japan: 'ja-JP',
    korea: 'ko-KR',
    china: 'zh-CN',
    czechrepublic: 'cz-CZ',
    denmark: 'dk-DK',
    france: 'fr-FR',
    germany: 'de-DE',
    greece: 'gr-GR',
    italy: 'it-IT',
    netherlands: 'nl-NL',
    poland: 'pl-PL',
    portugal: 'pt-PT',
    spain: 'es-ES',
    sweden: 'se-SE',
    uk: 'en-GB',
    austria: 'de-AT',
    ireland: 'en-IE',
    belgium: 'en-BE',
    luxembourg: 'en-LU',
  },
  emailFlags: {
    none: 0,
    optional: 1,
    required: 2,
    membership: 3,
    optin: 4,
  },
  countryCurrencyAssoc: [
    { countryCode: 32, currency: '$' },
    { countryCode: 40, currency: '€' },
    { countryCode: 56, currency: '€' },
    { countryCode: 124, currency: '$' },
    { countryCode: 152, currency: '$' },
    { countryCode: 156, currency: '¥' },
    { countryCode: 158, currency: '$' },
    { countryCode: 191, currency: 'kn' },
    { countryCode: 203, currency: 'CZK' },
    { countryCode: 208, currency: 'DKK' },
    { countryCode: 246, currency: '€' },
    { countryCode: 250, currency: '€' },
    { countryCode: 276, currency: '€' },
    { countryCode: 344, currency: '$' },
    { countryCode: 345, currency: 'MOP' },
    { countryCode: 348, currency: 'HUF' },
    { countryCode: 356, currency: '₹' },
    { countryCode: 360, currency: 'IDR' },
    { countryCode: 372, currency: '€' },
    { countryCode: 376, currency: '₪' },
    { countryCode: 380, currency: '€' },
    { countryCode: 392, currency: '円' },
    { countryCode: 410, currency: '₩' },
    { countryCode: 458, currency: 'RM' },
    { countryCode: 484, currency: 'MXN' },
    { countryCode: 528, currency: '€' },
    { countryCode: 578, currency: 'NOK' },
    { countryCode: 608, currency: '₱' },
    { countryCode: 616, currency: 'PLN' },
    { countryCode: 620, currency: '€' },
    { countryCode: 643, currency: '₽' },
    { countryCode: 702, currency: 'S$' },
    { countryCode: 704, currency: '₫' },
    { countryCode: 724, currency: '€' },
    { countryCode: 752, currency: 'SEK' },
    { countryCode: 756, currency: 'CHF' },
    { countryCode: 764, currency: 'THB' },
    { countryCode: 826, currency: '£' },
    { countryCode: 840, currency: '$' },
  ],
  passplayCultureMapping: new Map<string, string>([
    ['dk-DK', 'da'],
    ['du-BE', 'nl'],
    ['es-419', 'es-MX'],
    ['se-SE', 'sv'],
    ['zh-CN', 'zh-Hans'],
    ['zh-TW', 'zh-Hant'],
    ['cz-CZ', 'cs'],
  ]),
  policyLocationIdGroups: {
    EU: [
      40, 56, 191, 203, 208, 246, 250, 276, 300, 348, 372, 376, 380, 442, 528, 578, 616, 620, 643,
      705, 724, 752, 756, 792, 826,
    ],
    MIDDLEEAST: [],
    NORTHAFRICA: [],
    NORTHAMERICA: [840, 124], //(usa, canada)
    MEXICO: [484],
    SOUTHAMERICA: [32, 152], //(chile, argentina)
    SOUTHEASTASIA: [360, 458, 608, 702, 704, 764], //(indonesia,malaysia, philippines, singapore, vietnam, thailand)
    PAC: [36, 554], //(AUS,NZ)
    GREATERCHINA: [156],
    JAPAN: [392],
    KOREA: [410],
    ETW: [702],
  },
};
